import {InputSProps} from "@FRAMEWORK/ui/types/d";
import styled from "styled-components";

interface InputProps extends InputSProps {
	width?: string;
}

const Number = styled.input`
	width: ${props => props.width || "60px"};
	height: 45px;
	border: 0 none;
	border-top: 1px solid var(--line-color);
	border-bottom: 1px solid var(--line-color);
	font-size: var(--medium-size);
	text-align: center;

	&[type="text"]:focus {
		border-color: var(--line-color);
		outline: none;
	}
`;

const NumberInput = ({width, ...props}: InputProps) => <Number type="text" width={width} {...props} />;

export default NumberInput;
